export const HOW_CONNECT_DISCOUNT = [
  {
    id: 1,
    title: 'Выберите квартиру во вторичке',
    descr: 'Откройте “Мои объявления” и перейдите на вкладку “Продажа”',
    list: [
      { value: 'Снизить ставку на объекты загородной и коммерческой недвижимости не получится', isBold: false },
      { value: 'Сервис доступен для объявлений размещенных вручную и через XML-фид', isBold: false },
    ],
    imageClass: 'my-offers',
  },
  {
    id: 2,
    title: 'Ознакомьтесь с условиями',
    descr: 'Перейдите в карточку объекта и нажмите на кнопку “Скидка на ипотеку”',
    list: [
      { value: 'После подключения вы должны быть готовы к снижению цены на квартиру при продаже', isBold: false },
      { value: 'В объявлении должна быть указана реальная цена недвижимости', isBold: true },
    ],
    imageClass: 'advert-no-discount',
  },
  {
    id: 3,
    title: 'Договоритесь о снижении цены',
    descr: 'На сделке собственник должен будет снизить стоимость на 3,4%',
    list: [
      { value: 'Размер скидки фиксированный', isBold: false },
      { value: 'Покупатель использует эту сумму для снижения ставки по ипотеке на 4%', isBold: false },
    ],
    imageClass: 'chat',
  },
  {
    id: 4,
    title: 'Подключите скидку',
    descr: 'Нажмите на соответствующую кнопку для снижения ставки для покупателя ',
    list: [
      { value: 'Добавим на объявление значок “Скидка на ипотеку 4%”', isBold: false },
      { value: 'Так вы покажете, что готовы снизить цену при продаже', isBold: false },
      { value: 'Менять цену в объявлении не нужно', isBold: true },
    ],
    imageClass: 'advert-with-discount',
  },
];
